export function filterComparativeParameter(
  object: {[key: string]: string | number | null | undefined | boolean}, 
  comparatives: string[]
): {[key: string]: string | number | null | undefined | boolean } {
  const keys = Object.keys(object);
  const filtered = {};
  keys.map(key => {
    if (comparatives.indexOf(key) > -1) {
      filtered[key] = object[key];
    }
  });
  return filtered;
}